import cx from 'classnames';


const Cell = ({className, value, children}) => {
    //const day = (value) ? value.getDate():0;
    //console.log(value, day);
    return (
        <div className={cx("cell", className)}>
            {children}
        </div>
    );
}

export default Cell;